// extracted by mini-css-extract-plugin
export default {"container":"Platform_container__idFXW","hide-sidebar":"Platform_hide-sidebar__YhqZw"};